export default function TableCell({className, ...props}) {

    return (
        <td className={`px-4 py-3 whitespace-no-wrap `} {...props}>
            <p className={`${className}`}>
                {
                    props.children
                }
            </p>
        </td>

    )
}